import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function ContactUs() {
  return (
  <>
  <Navigation/>
    <section className="contact-us">
        <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
    <div className="left-col">
        <h2 className="contact-title">
            Έχετε κάποια ερώτηση; Επικοινωνήστε μαζί μας!
        </h2>
        <p className="contact-text">
            Επικοινωνήστε μαζί μας! Εκτιμούμε τα σχόλιά σας και είμαστε πάντα εδώ για να σας βοηθήσουμε. 
            Αφήστε μας ένα μήνυμα και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατόν.
        </p>
    </div>
    <div className="right-col">
        <form action="">
            <div className="input-wrapper">
                <label for="name">
                    Όνομα <span>(απαραίτητο)</span> 
                </label>
                <input type="text" name="name" id="name"/>
            </div>
            <div className="input-wrapper">
                <label for="email">
                    Email <span>(απαραίτητο)</span> 
                </label>
                <input type="text" name="email" id="email"/>
            </div>
            <div className="input-wrapper">
                <label for="comment">
                    Μήνυμα
                </label>
                <textarea name="comment" id="comment"></textarea>
            </div>
            <button type="button">
                Υποβολή
            </button>
        </form>
    </div>
</div>

        </div>
    </section>
    <Footer/>
  </>
  )
}

export default ContactUs